
import { Vue, Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import BarcodeOrderModule from "@/store/modules/barcodeSystem/barcodeOrder";
import { DeliverySignatureResource } from "@/models/api/barcodeSystem/barcodeOrders/get";
import { formatDateWithTime } from "@/utils";
import notifications from "@/lib/notifications";

const barcodeOrderModuleState = getModule(BarcodeOrderModule);

@Component
export default class BarcodeOrderDeliverySignatures extends Vue {
  @Prop({ default: false })
  loading: boolean;
  signatureUrls: any[] = null;

  get deliverySignatures(): Array<DeliverySignatureResource> {
    return barcodeOrderModuleState.currentBarcodeDeliverySignatures;
  }

  get totalItems() {
    if (barcodeOrderModuleState.currentBarcodeDeliverySignatures) {
      return barcodeOrderModuleState.currentBarcodeDeliverySignatures.length
    } else {
      return 0;
    }
  }

  formatDateWithTime(val)
  {
    return formatDateWithTime(val)
  }
}
